// ========================================
// UTILITAIRE - Format Date
// Formater les dates pour l'affichage
// ========================================

import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Formater une date en format lisible
 */
export const formatDate = (date, formatStr = 'dd MMMM yyyy') => {
  if (!date) return '';
  
  let dateObj = date;
  
  // Si c'est un timestamp Firebase
  if (date?.toDate) {
    dateObj = date.toDate();
  }
  // Si c'est une string
  else if (typeof date === 'string') {
    dateObj = parseISO(date);
  }
  
  if (!isValid(dateObj)) return '';
  
  return format(dateObj, formatStr, { locale: fr });
};

/**
 * Formater une date en format relatif (il y a X jours)
 */
export const formatRelativeDate = (date) => {
  if (!date) return '';
  
  let dateObj = date;
  
  if (date?.toDate) {
    dateObj = date.toDate();
  } else if (typeof date === 'string') {
    dateObj = parseISO(date);
  }
  
  if (!isValid(dateObj)) return '';
  
  return formatDistanceToNow(dateObj, { addSuffix: true, locale: fr });
};

/**
 * Formater une date courte
 */
export const formatShortDate = (date) => {
  return formatDate(date, 'dd/MM/yyyy');
};

/**
 * Formater une date avec l'heure
 */
export const formatDateTime = (date) => {
  return formatDate(date, 'dd MMMM yyyy à HH:mm');
};

export default formatDate;